import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RegisteredRoute: React.FC<{
  element: React.ReactElement;
  authed: boolean;
}> = ({ element, authed }) => {
  const location = useLocation();
  return authed ? (
    element
  ) : (
    <Navigate
      to="/login"
      state={{
        from: location.pathname,
      }}
    />
  );
};

export default RegisteredRoute;
